import React from 'react'
import styles from './index.module.less'
import { Divider } from 'antd'
export default function Contact() {
  return (
    <div className={styles.box}>
      <div className={styles.cont}>
        <span className={styles.big_title}>联系我们</span><br />
        <img className={styles.big_img} src="https://ts2.cn.mm.bing.net/th?id=ORMS.3cf981644368b126f723d0db785d388d&pid=Wdp&w=300&h=156&qlt=90&c=1&rs=1&dpr=1.2395833730697632&p=0" alt="" />
        <p>作为一家富有创意的商业活动管理公司，会誉会展专注为中国及亚太市场中的优秀企业、政府机构、非政府和非营利组织提供活动管理服务，以创意连接为服务宗旨，将实现商业全球化互通作为必修课，帮助来自各行各业的客户刷新行业认知、解决行业痛点、精准对接商机，成为立足华东、辐射全国、面向世界的行业活动实干者。</p>
        <p>会誉会展的核心团队均来自于国内外知名会展以及咨询企业。历经多年大型活动的经验沉淀，敏锐的洞察力、持续的创造力、高效的执行力、出色的协调力、专注且易于合作的职业精神、系统且精密的专业知识使得会誉会展团队从战略和规划到交付与审查，都是值得信赖的专业团队。</p>
        <div className={styles.contact}>
          <Divider orientation='left' plain className={styles.divider}>官方微信</Divider>
          <img src="https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/gsErWei.jpg" alt="" />
          <Divider orientation='left' plain className={styles.divider}>电话</Divider>
          <span className={styles.text}>+86 21 6125 8698</span>
          <Divider orientation='left' plain className={styles.divider}>邮箱</Divider>
          <span className={styles.text}>mkt@huiyuexpo.com</span>
          <Divider orientation='left' plain className={styles.divider}>地址</Divider>
          <span className={styles.text}>上海市普陀区中江路388 国盛中心1号楼1901-1902</span>
        </div>
      </div>
    </div>
  )
}
